import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: 'toggle'
        }
    }

    init() {
        this.isOpen = false
    }

    toggle(e) {
        let moduleEl = this.el;
        
        // check if data-class exist, .is-active is default
        let elmClass = "is-active";
        if (moduleEl.getAttribute('data-class')) {
            elmClass = moduleEl.getAttribute('data-class');
        }

        // scope elementTarget for class toggling to .barba-container
        let elmTarget = document.querySelector('body');

        // Overwrite elementTarget if it exist on element
        
        if (moduleEl.getAttribute('data-target')) {
            elmTarget = moduleEl.getAttribute('data-target');
        }

        if(moduleEl.getAttribute('data-ariahidden-toggle')){
            let ariaHiddenElm = document.querySelector(moduleEl.getAttribute('data-ariahidden-toggle'));
            if(ariaHiddenElm.getAttribute('aria-hidden') == "false"){
                ariaHiddenElm.setAttribute('aria-hidden','true')
            }else{
                ariaHiddenElm.setAttribute('aria-hidden','false')
            }
        }

        // ... class toggle
        let elmTargets = document.querySelectorAll(elmTarget);
        elmTargets.forEach(targetEl => {
            targetEl.classList.toggle(elmClass);
        });

        // If Focus is needed (like search input), focus on element.
        if (moduleEl.getAttribute('data-focus')) {
            document.querySelector(moduleEl.getAttribute('data-focus')).focus();
        }


        if (moduleEl.getAttribute('data-nav')) {
            let resetQuickLinks = document.querySelectorAll('.c-nav-sidebar__item')
            classRemove(resetQuickLinks, 'is-active');
            classRemove(document.querySelector('html'), 'has-search-open');
        }

        if (moduleEl.getAttribute('data-search')) {
            classRemove(document.querySelector('html'), 'has-nav-open');
        }
        
        // Log the clicked element in the console
        e.preventDefault();
        
    }
}

/*
    USAGE :
    <div class="myElement" data-module="classToggle" data-target=".c-header" data-class="toggleThisClass" data-focus=".myInputClass"></div>

    data-class :     [text element "has-state-open"]     Is required and will toggle this class on data-target
    data-target : [scoped element ".myClass"]         Isn't required, if not it falls back to .barba-container
    data-focus :     [scoped element ".myClass"]         Isn't required, focus the element when clicked (Ex. search input)
 */